<template>
    <div class="container container-noticies-block container-noticies-block--home" v-if="content">
        <div class="row">
            <div class="col-12">
                <div class="container-title">
                    <p>{{content.title}}</p>
                </div>
            </div>
        </div>
        <div class="row" v-if="noticias">
            <div class="col-sm-12 col-md-6 col-lg-3" v-if="noticias.hasOwnProperty(0)">
                <router-link :to="noticias[0].url" target="_self" class="noticies-item">
                    <div class="noticies-item--image noticies-item--image-featured">
                        <img :src="utils.image(noticias[0].image, 256, 560)" alt="">
                    </div>
                    <div class="noticies-item--info">
                        <p class="noticies__label"><strong>{{noticias[0].hat || noticias[0].editorial.title}}</strong></p>
                        <p class="noticies__title noticies__title--white"><strong>{{noticias[0].title}}</strong></p>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <div class="row">
                    <div class="col-12" v-if="noticias.hasOwnProperty(1)">
                        <router-link :to="noticias[1].url" target="_self" class="noticies-item">
                            <div class="noticies-item--image noticies-item--image-featured">
                                <img :src="utils.image(noticias[1].image, 544, 304)" alt="">
                            </div>
                            <div class="noticies-item--info">
                                <p class="noticies__label"><strong>{{noticias[1].hat || noticias[1].editorial.title}}</strong></p>
                                <p class="noticies__title noticies__title--white"><strong>{{noticias[1].title}}</strong></p>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6" v-for="noticia in noticias.slice(2,4)" :key="noticia.id">
                        <router-link :to="noticia.url" target="_self" class="noticies-item noticies-item--bottom">
                            <div class="noticies-item--image noticies-item--image-side">
                                <img :src="utils.image(noticia.image, 256, 224)" alt="">
                            </div>
                            <div class="noticies-item--info">
                                <p class="noticies__label"><strong>{{noticia.hat || noticia.editorial.title}}</strong></p>
                                <p class="noticies__title noticies__title--white"><strong>{{noticia.title}}</strong></p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-3 container-noticies-last">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-12" v-if="noticias.hasOwnProperty(4)">
                        <router-link :to="noticias[4].url" target="_self" class="noticies-item">
                            <div class="noticies-item--image">
                                <img :src="utils.image(noticias[4].image, 256, 304)" alt="">
                            </div>
                            <div class="noticies-item--info">
                                <p class="noticies__label"><strong>{{noticias[4].hat || noticias[4].editorial.title}}</strong></p>
                                <p class="noticies__title noticies__title--white"><strong>{{noticias[4].title}}</strong></p>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-12 col-md-6 col-lg-12" v-if="noticias.hasOwnProperty(5)">
                        <router-link :to="noticias[5].url" target="_self" class="noticies-item noticies-item--bottom">
                            <div class="noticies-item--image">
                                <img :src="utils.image(noticias[5].image, 256, 224)" alt="">
                            </div>
                            <div class="noticies-item--info">
                                <p class="noticies__label"><strong>{{noticias[5].hat || noticias[5].editorial.title}}</strong></p>
                                <p class="noticies__title noticies__title--white"><strong>{{noticias[5].title}}</strong></p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'
import api from '@/api'

export default {
    name: 'Extra',
    props:['content'],
    data() {
        return {
            utils: utils,
            noticias: null,
        }
    },
    watch: {
        content: function() {
            this.getNoticias()
        }
    },
    methods:{
        async getNoticias () {
            if (this.content) {
                const response = await api.get('pages/',{
                    type:'news.NewsPage',
                    descendant_of: this.content.id,
                    fields:'url,image,editorial,hat',
                    order: '-first_published_at',
                    limit: 6,
                })
    
                if (response.ok) {
                    this.noticias = response.data.items
                }
            }
        }
    },
}
</script>